import React from 'react';
import { ReplaySlider } from './ReplaySlider/index.ts';
import { AvatarList } from './AvatarList/index.ts';
import { ControlButton } from './ControlButton/index.ts';
import styles from './ReplayControlsContent.module.scss';
import clsx from 'clsx';
import IconRewind from '@static/images/icon_rewind.svg';
import IconPause from '@static/images/icon_pause.svg';
import IconPlay from '@static/images/icon_play.svg';
import IconFastForward from '@static/images/icon_forward.svg';
import { T } from '@colonist/ui';
export const ReplayControlsContentMinimal = ({ isPlaying, onTogglePlayback, onPreviousAction, onNextAction, currentPlayerPerspective, playerUserStates, onChangePerspective, numberOfActions, currentActionIndex, onSliderChangeActionIndex, highlightData, className, disableTooltips })=>{
    const hasHighlightData = highlightData.length > 0;
    return /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.replayControlsContainer, className)
    }, /*#__PURE__*/ React.createElement(ReplaySlider, {
        highlightData: highlightData,
        max: numberOfActions,
        onChange: onSliderChangeActionIndex,
        shouldShowHighlights: hasHighlightData,
        value: currentActionIndex
    }), /*#__PURE__*/ React.createElement("div", {
        className: clsx(styles.bottomMenu, styles.bottomMenuVisible)
    }, /*#__PURE__*/ React.createElement("div", {
        className: styles.controllerButtons
    }, /*#__PURE__*/ React.createElement(ControlButton, {
        icon: IconRewind,
        alt: "strings:imgAlts.Rewind",
        disabled: currentActionIndex <= -1,
        onClick: onPreviousAction,
        tooltipContent: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tooltips.replay.previousAction"
        }),
        disableTooltip: disableTooltips
    }), isPlaying ? /*#__PURE__*/ React.createElement(ControlButton, {
        icon: IconPause,
        alt: "strings:imgAlts.Pause",
        onClick: onTogglePlayback,
        tooltipContent: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tooltips.replay.playPause"
        }),
        disableTooltip: disableTooltips
    }) : /*#__PURE__*/ React.createElement(ControlButton, {
        icon: IconPlay,
        alt: "strings:imgAlts.Play",
        onClick: onTogglePlayback,
        tooltipContent: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tooltips.replay.playPause"
        }),
        disableTooltip: disableTooltips
    }), /*#__PURE__*/ React.createElement(ControlButton, {
        icon: IconFastForward,
        alt: "strings:imgAlts.FastForward",
        onClick: onNextAction,
        tooltipContent: /*#__PURE__*/ React.createElement(T, {
            id: "strings:game.tooltips.replay.nextAction"
        }),
        disableTooltip: disableTooltips
    })), /*#__PURE__*/ React.createElement(AvatarList, {
        currentPlayerPerspective: currentPlayerPerspective,
        onChangePerspective: onChangePerspective,
        playerUserStates: playerUserStates
    })));
};
